"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTileInRangeArea = exports.computeActionArea = void 0;
var tilemap_utils_1 = require("@timeflies/tilemap-utils");
var computeActionArea = function (_a) {
    var spellAction = _a.partialSpellAction, context = _a.context;
    var spellId = spellAction.spellId, targetPos = spellAction.targetPos;
    var _b = context.map, tiledMap = _b.tiledMap, rangeArea = _b.rangeArea;
    var actionAreaValue = context.state.spells.actionArea[spellId];
    if (!exports.isTileInRangeArea(rangeArea, targetPos)) {
        return [];
    }
    return tilemap_utils_1.Area.getArea(targetPos, actionAreaValue, tiledMap)
        .filter(function (p) { return tilemap_utils_1.Tile.getTileTypeFromPosition(p, tiledMap) === 'default'; });
};
exports.computeActionArea = computeActionArea;
var isTileInRangeArea = function (rangeArea, targetPos) { return rangeArea.some(function (p) { return p.id === targetPos.id; }); };
exports.isTileInRangeArea = isTileInRangeArea;
